var map = {
	"./kg": [
		480,
		3
	],
	"./kg.js": [
		480,
		3
	],
	"./ru": [
		481,
		4
	],
	"./ru.js": [
		481,
		4
	],
	"./translation.service": [
		477,
		5
	],
	"./translation.service.js": [
		477,
		5
	],
	"./translation.types": [
		475,
		6
	],
	"./translation.types.js": [
		475,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 567;
module.exports = webpackAsyncContext;